export default __webpack_public_path__ + "static/media/scC.6c331ee2.webp";